export const data = [
  {
    id: 5,
    name: "Jean-Michel Basquiat 2",
    brand: "jordan",
    image: "/assets/shoesbrand/jordan/Jean-Michel Basquiat 2.jpg",
  },
  {
    id: 1,
    name: "Acrylic",
    brand: "nike",
    image: "/assets/shoesbrand/nike/Acrylic.jpg",
  },
  {
    id: 19,
    name: "Winnie The Pooh",
    brand: "soccer",
    image: "/assets/shoesbrand/soccer/Winnie The Pooh.jpg",
  },
  {
    id: 3,
    name: "Iron Ore",
    brand: "nike",
    image: "/assets/shoesbrand/nike/Iron Ore.jpg",
  },
  {
    id: 8,
    name: "Kehinde Wiley 3",
    brand: "jordan",
    image: "/assets/shoesbrand/jordan/Kehinde Wiley 3.jpg",
  },
  {
    id: 16,
    name: "Frozen",
    brand: "soccer",
    image: "/assets/shoesbrand/soccer/Frozen.jpg",
  },
  {
    id: 7,
    name: "Kehinde Wiley 2",
    brand: "jordan",
    image: "/assets/shoesbrand/jordan/Kehinde Wiley 2.jpg",
  },
  {
    id: 14,
    name: "Cinderella",
    brand: "soccer",
    image: "/assets/shoesbrand/soccer/Cinderella.jpg",
  },
  {
    id: 9,
    name: "Kehinde Wiley 4",
    brand: "jordan",
    image: "/assets/shoesbrand/jordan/Kehinde Wiley 4.jpg",
  },
  {
    id: 2,
    name: "Gold",
    brand: "nike",
    image: "/assets/shoesbrand/nike/Gold.jpg",
  },
  {
    id: 18,
    name: "Wall-E",
    brand: "soccer",
    image: "/assets/shoesbrand/soccer/Wall-E.jpg",
  },
  {
    id: 11,
    name: "Lisa Frank",
    brand: "jordan",
    image: "/assets/shoesbrand/jordan/Lisa Frank.jpg",
  },
  {
    id: 21,
    name: "Air Force 1",
    brand: "nike",
    image: "/assets/card2.jpg",
  },
  {
    id: 12,
    name: "Aladdin",
    brand: "soccer",
    image: "/assets/shoesbrand/soccer/Aladdin.jpg",
  },
  {
    id: 6,
    name: "Jean-Michel Basquiat",
    brand: "jordan",
    image: "/assets/shoesbrand/jordan/Jean-Michel Basquiat.jpg",
  },
  {
    id: 4,
    name: "Led",
    brand: "nike",
    image: "/assets/shoesbrand/nike/Led.jpg",
  },
  {
    id: 13,
    name: "Beauty And The Beast",
    brand: "soccer",
    image: "/assets/shoesbrand/soccer/Beauty And The Beast.jpg",
  },
  {
    id: 15,
    name: "Coco",
    brand: "soccer",
    image: "/assets/shoesbrand/soccer/Coco.jpg",
  },
  {
    id: 22,
    name: "Cortez",
    brand: "nike",
    image: "/assets/card3.jpg",
  },
  {
    id: 10,
    name: "Kehinde Wiley",
    brand: "jordan",
    image: "/assets/shoesbrand/jordan/Kehinde Wiley.jpg",
  },
  {
    id: 23,
    name: "Air Max 270",
    brand: "nike",
    image: "/assets/card1.jpg",
  },
  {
    id: 17,
    name: "Luca",
    brand: "soccer",
    image: "/assets/shoesbrand/soccer/Luca.jpg",
  },
];
